<template>

    <div class="container">

        <app-head title="Mail Log" />

        <h1>
            {{ mailLog.subject }}
        </h1>
        
        <div class="bg-white rounded-lg p-3">
            <table>
                <tbody>
                    <tr>
                        <th>{{ __('From') }}</th>
                        <td>{{ mailLog.from }}</td>
                    </tr>
                    <tr>
                        <th>{{ __('To') }}</th>
                        <td>{{ mailLog.to }}</td>
                    </tr>
                    <tr>
                        <th>{{ __('Reply to') }}</th>
                        <td>{{ mailLog.reply_to }}</td>
                    </tr>
                    <tr>
                        <th>{{ __('CC') }}</th>
                        <td>{{ mailLog.cc }}</td>
                    </tr>
                    <tr>
                        <th>{{ __('BCC') }}</th>
                        <td>{{ mailLog.bcc }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div v-html="mailLog.body">
        </div>

    </div>

</template>

<script>

    export default {
        props: [
            'mailLog',
        ],
        components: {

        },
        data() {
            return {

            }
        },
        watch: {

        },
        methods: {

        },
    }
</script>